<template>
  <div class="page-select-groups">
    <div class="page-select-content" v-for="(item,index) in searchList" :key="index">
      <span class="title" v-if="item.title">{{item.title}}</span>
      <template v-if="item.slotName">
        <slot :name="item.slotName"></slot>
      </template>
      <template v-else>
        <el-select
          clearable
          v-model="selectParams[item.prop]"
          :placeholder="item.placeholder"
          :disabled="showDisabled(item)"
          @change="(val) => handleComponent(val, item, 1)"
          :multiple="item.multiple || false"
          :collapse-tags="item.collapseTags || false"
          :size="formSize"
          v-bind="item.attrs"
        >
          <el-option label="全部" value="" v-if="!item.hasAll"></el-option>
          <el-option
            v-for="dictItem in dictDataSource(item)"
            :key="getDictValue(item, dictItem)"
            :label="getDictLabel(item, dictItem)"
            :value="getDictValue(item, dictItem)"
          ></el-option>
        </el-select>
      </template>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  props: {
    // 查询参数值
    searchValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 查询条件列表search-list
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    searchList() {
      return this.selectList;
    },
    selectParams: {
      get() {
        return this.searchValue;
      },
      set(val) {
        const objValue = cloneDeep(val);
        this.$emit('update:searchValue', { ...this.searchValue, ...objValue });
      },
    },
    dictDataSource() {
      return (columnItem) => {
        const { dictData } = this.$store.state.dictionary;
        if (columnItem.dictStoreActionName) {
          return dictData[columnItem.dictStoreActionName] || [];
        }
        if (columnItem.dictionaryPath) {
          return dictData[columnItem.dictionaryPath] || [];
        }
        return columnItem?.dictData || [];
      };
    },
    getDictLabel() {
      return (columnItem, dictItem) => (columnItem.dictLabelName ? dictItem[columnItem.dictLabelName] : dictItem?.codeName);
    },
    getDictValue() {
      return (columnItem, dictItem) => (columnItem.dictValueName ? dictItem[columnItem.dictValueName] : dictItem?.value);
    },
    // 判断是否传入disabled
    showDisabled() {
      return (column) => {
        if (typeof column.disabled === 'function') {
          return column.disabled();
        } if (typeof column.disabled === 'boolean') {
          return column.disabled;
        }
        return false;
      };
    },
  },
  mounted() {
    const dictPathArr = [];
    const { dictData } = this.$store.state.dictionary;

    this.searchList.forEach((item) => {
      if (item.dictStoreActionName) {
        this.$store.dispatch({
          type: item.dictStoreActionName,
          params: item.dictParams || {},
        });
      }
      if (item.dictionaryPath && !dictData[item.dictionaryPath]) {
        dictPathArr.push(item.dictionaryPath);
      }
    });
    if (dictPathArr.length) {
      this.$store.dispatch({
        type: 'dictionary/getDictionaryPath',
        paths: dictPathArr,
      });
    }
  },
  methods: {
    // 触发事件
    handleComponent(val, columnItem, type) {
      const typeObj = {
        1: 'enter',
        2: 'change',
      };
      if (columnItem.attrs && typeof columnItem.attrs.enter === 'function' && typeObj[type] === 'enter') {
        columnItem.attrs.enter(val);
      }
      if (columnItem.attrs && typeof columnItem.attrs.change === 'function' && typeObj[type] === 'change') {
        columnItem.attrs.change(val);
      }
      this.$emit('change');
    },
  },
};
</script>


<style lang="scss">
.page-select-groups {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;
  .page-select-content {
    margin-bottom: 0;
    margin-right: 32px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:last-child {
      margin-right: 0;
    }
    .title {
      padding-right: 8px;
      color: #2a304d;
      font-size: inherit;
      white-space: nowrap;
    }
  }
  .el-select {
    max-width: 110px;
  }
}
</style>
